import { render, staticRenderFns } from "./scopecenter8.vue?vue&type=template&id=31756470&scoped=true"
import script from "./scopecenter8.vue?vue&type=script&lang=js"
export * from "./scopecenter8.vue?vue&type=script&lang=js"
import style0 from "./scopecenter8.vue?vue&type=style&index=0&id=31756470&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31756470",
  null
  
)

export default component.exports